// Central product catalog — edit here to add/remove products
// Images are real product photographs bundled with the app.
// To swap in your own photos: drop your jpeg/webp into src/assets/products/
// with the same filename, or update the import paths below.

import cuminImg from "../assets/products/cumin.webp";
import fennelImg from "../assets/products/fennel.jpg";
import corianderImg from "../assets/products/coriander.jpg";
import blackSesameImg from "../assets/products/black-sesame.webp";
import whiteSesameImg from "../assets/products/white-sesame.jpg";
import redChillyImg from "../assets/products/red-chilly.webp";

const products = [
  {
    slug: "cumin-seeds",
    name: "Cumin Seeds",
    local: "Jeera",
    tagline: "Warm, earthy, the heartbeat of the subcontinent's kitchen.",
    color: "#8B6F47",
    image: cuminImg,
    origin: "Gujarat & Rajasthan, India",
    grade: "Machine-cleaned, Singapore & Europe quality",
    moisture: "≤ 9%",
    purity: "99% / 99.5% / 99.95%",
    packing: "25 / 50 kg PP bags · jute bags · custom packing",
    hsCode: "0909.31",
    uses: [
      "Whole spice for tempering",
      "Ground cumin powder",
      "Essential oil extraction",
      "Traditional & herbal medicine",
    ],
  },
  {
    slug: "fennel-seeds",
    name: "Fennel Seeds",
    local: "Saunf",
    tagline: "Sweet, aromatic seeds prized across cuisines and medicine.",
    color: "#4A6B3A",
    image: fennelImg,
    origin: "Gujarat, India",
    grade: "Europe & Gulf export quality",
    moisture: "≤ 10%",
    purity: "98% / 99% / 99.5%",
    packing: "25 / 50 kg PP or jute bags · custom packing",
    hsCode: "0909.61",
    uses: [
      "Culinary — whole & ground",
      "Mouth freshener & digestive",
      "Herbal teas",
      "Essential oil extraction",
    ],
  },
  {
    slug: "coriander-seeds",
    name: "Coriander Seeds",
    local: "Dhaniya",
    tagline: "Bright, citrusy — the quiet backbone of every curry.",
    color: "#D98B2B",
    image: corianderImg,
    origin: "Rajasthan & Madhya Pradesh, India",
    grade: "Singapore, Europe & Gulf quality",
    moisture: "≤ 9%",
    purity: "98% / 99% / 99.5%",
    packing: "25 / 50 kg PP or jute bags · custom packing",
    hsCode: "0909.21",
    uses: [
      "Whole & ground culinary use",
      "Pickling & brining",
      "Ayurvedic preparations",
      "Essential oil extraction",
    ],
  },
  {
    slug: "black-sesame-seeds",
    name: "Black Sesame Seeds",
    local: "Kala Til",
    tagline: "Rich, nutty, visually striking — a superfood with depth.",
    color: "#1F1A14",
    image: blackSesameImg,
    origin: "Gujarat, India",
    grade: "Food grade · 99.95% purity available",
    moisture: "≤ 6%",
    purity: "98% / 99% / 99.95%",
    packing: "25 / 50 kg PP or jute bags · custom packing",
    hsCode: "1207.40",
    uses: [
      "Bakery & confectionery",
      "Tahini & sesame oil",
      "Asian & Middle-Eastern cuisine",
      "Nutraceuticals",
    ],
  },
  {
    slug: "white-sesame-seeds",
    name: "White Sesame Seeds",
    local: "Safed Til",
    tagline: "Clean, versatile, globally loved — from sushi to halwa.",
    color: "#C9A876",
    image: whiteSesameImg,
    origin: "Gujarat, India",
    grade: "Hulled & natural, food grade",
    moisture: "≤ 6%",
    purity: "99% / 99.95% / 99.98%",
    packing: "25 / 50 kg PP or jute bags · custom packing",
    hsCode: "1207.40",
    uses: [
      "Bakery toppings",
      "Oil extraction",
      "Tahini & halwa",
      "Asian confectionery",
    ],
  },
  {
    slug: "red-chilly",
    name: "Red Chilly",
    local: "Lal Mirch",
    tagline: "From mild Kashmiri to fiery Teja — heat and colour you can trust.",
    color: "#B8432A",
    image: redChillyImg,
    origin: "Andhra Pradesh, Karnataka & Gujarat, India",
    grade: "Stemless & with stem · Teja · Sannam · Kashmiri",
    moisture: "≤ 11%",
    purity: "Hand-picked & graded",
    packing: "10 / 20 / 25 kg cartons · jute bags · custom packing",
    hsCode: "0904.21",
    uses: [
      "Whole, flaked, and powdered",
      "Oleoresin & colour extraction",
      "Global cuisine",
      "Pickles & sauces",
    ],
  },
];

export default products;
